var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"card radius-10 border-0"},[_c('div',{staticClass:"bound-border"},[_c('div',{staticClass:"p-10-10"},[_c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"padding":"51px 0 152px 0"}},[_c('div',{staticClass:"col-md-8"},[_c('div',[_c('ChangePassword')],1)])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }